import React from 'react'
import PropTypes from 'prop-types'

import { toTitle } from '../../../../common/utils/formatString'

const MetaCategories = ({ className, classification }) => {
  const categories = classification.split('/')
  return (
    <span className={className}>
      in{' '}
      {categories.map((category, index) => {
        const slash = index === categories.length - 1 ? null : ' / '
        return (
          <span key={index}>
            <b>{toTitle(category)}</b>
            {slash}
          </span>
        )
      })}
    </span>
  )
}

MetaCategories.propTypes = {
  className: PropTypes.string,
  classification: PropTypes.string.isRequired
}

export default MetaCategories



// WEBPACK FOOTER //
// ./client/pages/search/result/metaCategories.js